var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInitalWhiteArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 10,
    viewBox: "0 0 5 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.17965 1.08607C0.281508 1.00124 0.412885 0.960329 0.544899 0.972331C0.676913 0.984332 0.798759 1.04826 0.88365 1.15007L4.21665 5.15007C4.26055 5.20025 4.29397 5.25871 4.31494 5.32199C4.33592 5.38528 4.34402 5.45212 4.33879 5.51858C4.33355 5.58505 4.31507 5.64979 4.28444 5.70901C4.25381 5.76823 4.21164 5.82072 4.16042 5.8634C4.10921 5.90609 4.04997 5.93809 3.9862 5.95754C3.92243 5.97699 3.85541 5.98349 3.78909 5.97666C3.72277 5.96983 3.65849 5.9498 3.60002 5.91776C3.54156 5.88571 3.49009 5.8423 3.44865 5.79007L0.11565 1.79007C0.030817 1.68822 -0.0100951 1.55684 0.0019059 1.42482C0.0139069 1.29281 0.0778403 1.17097 0.17965 1.08607Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.17965 9.85397C0.0778401 9.76908 0.0139068 9.64724 0.00190572 9.51522C-0.0100953 9.38321 0.0308168 9.25183 0.11565 9.14997L3.44865 5.14997C3.49009 5.09775 3.54156 5.05433 3.60002 5.02229C3.65849 4.99025 3.72277 4.97022 3.78909 4.96339C3.85541 4.95655 3.92243 4.96305 3.9862 4.9825C4.04997 5.00195 4.10921 5.03396 4.16042 5.07664C4.21164 5.11933 4.25381 5.17182 4.28444 5.23104C4.31507 5.29026 4.33355 5.355 4.33879 5.42147C4.34402 5.48793 4.33592 5.55477 4.31494 5.61806C4.29397 5.68134 4.26055 5.73979 4.21665 5.78997L0.883649 9.78997C0.798758 9.89178 0.676913 9.95572 0.544899 9.96772C0.412885 9.97972 0.281508 9.93881 0.17965 9.85397Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInitalWhiteArrow);
export default __webpack_public_path__ + "static/media/inital_white_arrow.1f0312b828cd6522fb96c6697966d652.svg";
export { ForwardRef as ReactComponent };